import { Checkbox } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'

interface LockedProps {}

const Locked: FC<LockedProps> = () => {
    const name = 'locked'

    return (
        <Form.Item name={name} label={' '} valuePropName={'checked'}>
            <Checkbox> Не использовать</Checkbox>
        </Form.Item>
    )
}

export default Locked
